export default "__VITE_ASSET__BupZSEqG__";